import DashboardIcon from '@mui/icons-material/Dashboard'
import BarChartIcon from '@mui/icons-material/BarChart'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat'
import DeviceHubIcon from '@mui/icons-material/DeviceHub'
import InventoryIcon from '@mui/icons-material/Inventory'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks'
import SearchIcon from '@mui/icons-material/Search'
import PeopleIcon from '@mui/icons-material/People'
import StoreIcon from '@mui/icons-material/Store'
import ImageIcon from '@mui/icons-material/Image'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'

// Full menu definition used by sidebar
export const menuConfig = [
    {
        group: 'Home',
        items: [
            { key: 'dashboard', label: 'Dashboard', icon: DashboardIcon, permission: 'manager' },
            { key: 'itemEvents', label: 'Search', icon: SearchIcon, permission: 'inventories' }
        ]
    },
    {
        group: 'Inventories',
        permission: 'inventories',
        items: [
            {
                key: 'inventories',
                label: 'Inventories',
                icon: InventoryIcon,
                permission: 'inventories'
            },
            {
                key: 'catalogues',
                label: 'Catalogues',
                icon: MenuBookIcon,
                permission: 'inventories'
            },
            {
                key: 'searchLists',
                label: 'Search Lists',
                icon: SearchIcon,
                permission: 'inventories'
            }
        ]
    },
    {
        group: 'Statistics',
        items: [
            { key: 'environmental', label: 'Environmental', icon: DeviceThermostatIcon, permission: 'statistics' },
            { key: 'counters', label: 'Visitors', icon: PeopleAltIcon, permission: 'statistics' },
            {
                key: 'sipStatistics',
                label: 'SIP',
                icon: LibraryBooksIcon,
                permission: 'selfcheck'
            }
        ]
    },
    {
        group: 'Infrastructure',
        items: [
            { key: 'nodes', label: 'Nodes', icon: DeviceHubIcon, permission: 'nodes' },
            { key: 'alarms', label: 'Book Alerts', icon: LibraryBooksIcon, permission: 'alarms' }
        ]
    },
    {
        group: 'Autoprestamos',
        items: [
            { key: 'sipOperations', label: 'SIP Operations', icon: ReceiptLongIcon, permission: 'selfcheck' },
            { key: 'imagesets', label: 'Image Sets', icon: ImageIcon, permission: 'selfcheck' }
        ]
    },
    {
        group: 'Management',
        items: [
            { key: 'users', label: 'Users', icon: PeopleIcon, permission: 'manager' },
            { key: 'stores', label: 'Stores', icon: StoreIcon, permission: 'manager' }
        ]
    }
]

// Bottom navigation tabs (mobile) — the main 4 + "More"
export const bottomNavItems = [
    { key: 'dashboard', label: 'Dashboard', icon: DashboardIcon },
    { key: 'counters', label: 'Statistics', icon: BarChartIcon },
    { key: 'nodes', label: 'Nodes', icon: DeviceHubIcon },
    { key: 'alarms', label: 'Book Alerts', icon: LibraryBooksIcon },
    { key: 'more', label: 'More', icon: MoreHorizIcon }
]
